import { RobotActions } from '../../utils/constants';

const { PROGRAM } = RobotActions;

export type DashboardLayoutLockInputs = {
  programState: string;
  isProgramActive: boolean;
};

/** Local deploy FSM states where dashboard layout must not drive program-code changes before runtime catches up. */
export function isDeployQueuedProgramState(programState: string): boolean {
  return programState === PROGRAM.SEND_STARTING || programState === PROGRAM.DOWNLOAD || programState === PROGRAM.DOWNLOAD_RUN;
}

/**
 * Whether dashboard drawer layout edits and stream-key persistence must be blocked.
 * Composes the runtime-aware active-program contract with queued deploy states so stale local
 * STOP/STOPPED values and runtime lag stay consistent with the status bar and robot selectors.
 */
export function isDashboardLayoutLocked({ programState, isProgramActive }: DashboardLayoutLockInputs): boolean {
  return isProgramActive || isDeployQueuedProgramState(programState);
}
